export enum RoleName {
  超级管理员 = '超级管理员',
}
